import { render } from "./StatusReportFollowupView.vue?vue&type=template&id=444591d6&scoped=true"
import script from "./StatusReportFollowupView.vue?vue&type=script&lang=js"
export * from "./StatusReportFollowupView.vue?vue&type=script&lang=js"

import "./StatusReportFollowupView.vue?vue&type=style&index=0&id=444591d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444591d6"]])

export default __exports__